import { ElementFactory } from "survey-core";

// Utility function to disable the tagbox (multi dropdown list) question type
// This should be called before creating any SurveyModel instances
export function disableMultiDropdownList() {
    try {
        // Remove the tagbox element from the ElementFactory
        // This prevents it from appearing in surveys and question type options
        ElementFactory.Instance.unregisterElement("tagbox", true);
        console.log("Multi dropdown list (tagbox) question type has been disabled");
    } catch (error) {
        // Element may not exist or already removed
        console.log("Tagbox element not found or already removed:", error.message);
    }
}

// Alternative approach: Override the tagbox registration to return null
export function disableTagboxRegistration() {
    try {
        // Override the tagbox element creation to return null
        ElementFactory.Instance.registerElement("tagbox", () => null);
        console.log("Multi dropdown list (tagbox) registration has been overridden");
    } catch (error) {
        console.log("Error overriding tagbox registration:", error.message);
    }
}